<template>
  <form ref="fileDownloadForm"
        :action="computedLink"
        class="d-inline-block"
        method="post"
        :target="isNewTab ? '_blank' : ''"
  >
    <!-- @slot Use this slot to display download trigger
          @binding {function} submitForm - Function to call for triggering download
     -->
    <slot v-bind:submitForm="submitForm"></slot>
  </form>
</template>

<script>
export default {
  name: 'AppDownloadFile',
  props: {
    /**
     * Link to download target
     */
    link: {
      type: String,
      required: true,
    },
    /**
     * If the link should open in a new tab
     */
    isNewTab: {
      type: Boolean,
      default: true,
    },
    /**
     * If the download must force the reader of the browser
     */
    forceReader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedLink () {
      const queryToAppend = this.forceReader
        ? 'forceReader=true'
        : 'forceDownload=true'
      // If this already has a query string.
      if (this.link.includes('?')) {
        // Don't be dumb and use an &
        // See V2-979... 🤦‍♂️
        return this.link + '&' + queryToAppend
      } else {
        return this.link + '?' + queryToAppend
      }
    },
  },
  methods: {
    // Submit the form natively (a document navigation) rather than fetch().
    // The download endpoint replies 302 to a presigned S3 URL; a fetch() follows
    // that redirect under CSP connect-src, which does not allow the S3 host and
    // blocks it ("Failed to fetch"). A native form submit follows the redirect as
    // a navigation instead, so it is not subject to connect-src. Auth relies on
    // the HttpOnly cookie, sent automatically, so no token is exposed in the form.
    submitForm () {
      this.$refs.fileDownloadForm.submit()
    },
  },
}
</script>
